import styled from '@emotion/styled';

export const NaturalPersonViewPageContainer = styled.div`
  width: 100%;
  height: 100%;
`;
